import request from "@/utils/request";
import ENDPOINT from "@/config/endpoint";

export async function fetchQuestionAnswer(params) {
  return await request({
    url: ENDPOINT.QUESTION_ANSWER,
    method: "get",
    params,
  });
}

export async function fetchQuestionAnswerById(id) {
  return await request({
    url: `${ENDPOINT.QUESTION_ANSWER}/${id}`,
    method: "get",
  });
}

export async function createQuestionAnswer(data) {
  return await request({
    url: ENDPOINT.QUESTION_ANSWER,
    method: "post",
    data,
  });
}

export async function updateQuestionAnswer(id, data) {
  return await request({
    url: `${ENDPOINT.QUESTION_ANSWER}/${id}`,
    method: "put",
    data,
  });
}

export async function removeQuestionAnswer(id) {
  return await request({
    url: `${ENDPOINT.QUESTION_ANSWER}/${id}`,
    method: "delete",
  });
}